import React from 'react'

import type {BuildTypeId} from '../../../../../../types'
import SvgIcon from '../../../../../common/SvgIcon/SvgIcon'

import styles from './PipelineStructureJob.css'

type Props = {
  x: number
  y: number
  jobId: BuildTypeId
}

export default function PipelineStructureJob({x, y, jobId}: Props) {
  return (
    <div className={styles.tile} style={{top: x, left: y}}>
      <SvgIcon className={styles.icon} icon="buildType-14px" />
      <div className={styles.name}>{jobId}</div>
    </div>
  )
}
